import React from 'react';
import styles from './styles.module.scss';
import { Text } from 'components/typography/Text';
import { FocusableElement } from 'components/FocusableElement';
import { CogIcon } from "assets/icons/CogIcon";
import { useSideMenu } from 'store/side-menu';

export const Settings = () => {
  const { setIsSideMenuOpen } = useSideMenu();

  return (
    <FocusableElement
      className={styles.settings}
      onClick={() => setIsSideMenuOpen(true)}
    >
      <div className={styles.text}>
        <Text size={14} intl="settings" />
      </div>

      <CogIcon />
    </FocusableElement>
  )
};
